import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-48d1e2f8")
const _hoisted_1 = { class: "purchase-record-contaner" }
const _hoisted_2 = { class: "top-content" }
const _hoisted_3 = { class: "statistics" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "收购单数(笔)", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "cup" }, null, -1)
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "交易数量(斤)", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "cup" }, null, -1)
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, "交易金额(元)", -1)
const _hoisted_12 = { class: "filter" }
const _hoisted_13 = { class: "filter-box" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("~")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1)
const _hoisted_17 = { class: "btn" }
const _hoisted_18 = { class: "filter-box" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1)
const _hoisted_20 = { class: "list-content" }
const _hoisted_21 = { class: "line_1" }
const _hoisted_22 = { class: "coo-item" }
const _hoisted_23 = { class: "line_2" }
const _hoisted_24 = { class: "line_3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "cup" }, null, -1)
const _hoisted_26 = { class: "bottom-content" }
const _hoisted_27 = { class: "right" }
const _hoisted_28 = { class: "title" }
const _hoisted_29 = { class: "price" }
const _hoisted_30 = { class: "unit" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "¥", -1)
const _hoisted_32 = {
  key: 1,
  class: "null-wrap"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "null-card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, "还没有收购哦～")
], -1)
const _hoisted_34 = [
  _hoisted_33
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_picker = _resolveComponent("van-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.loading,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.loading = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", null, _toDisplayString(_ctx.statisticsData.countSn), 1)
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", null, _toDisplayString(_ctx.statisticsData.sumNumber), 1)
            ]),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", null, _toDisplayString(_ctx.statisticsData.sumPrice), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", {
                class: "box time",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickDateFilter && _ctx.onClickDateFilter(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.transformDates(_ctx.startDate, 1)), 1),
                _hoisted_14,
                _createElementVNode("span", null, _toDisplayString(_ctx.transformDates(_ctx.endDate, 2)), 1),
                _hoisted_15
              ]),
              _createElementVNode("div", {
                class: "box date",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickWayFilter && _ctx.onClickWayFilter(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.selectedDateWay.text), 1),
                _hoisted_16
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
                }, "重置")
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", {
                class: "box variety",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickTypeFilter && _ctx.onClickTypeFilter(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.selectedType[_ctx.selectedType.length - 1].id < 0
                  ? "全部品种"
                  : _ctx.selectedType[_ctx.selectedType.length - 1].name), 1),
                _hoisted_19
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          (_ctx.dataList.length > 0)
            ? (_openBlock(), _createBlock(_component_van_list, {
                key: 0,
                offset: 0,
                finished: _ctx.total === _ctx.dataList.length,
                "finished-text": "我已经到底了~~~",
                class: "list-wrap",
                onLoad: _ctx.onLoad
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "card",
                      key: item
                    }, [
                      _createVNode(_component_van_image, {
                        class: "bg",
                        src: "https://qnui.xfarmer.com/xfarmer-ui/h5Purchase/jianying.png"
                      }),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(item.cooperationName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", null, "单据编号：" + _toDisplayString(item.id), 1),
                        _createElementVNode("div", null, "收购日期：" + _toDisplayString(item.ledgerDate), 1)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", null, "制单人：" + _toDisplayString(item.createUser), 1),
                        _createElementVNode("div", null, "供应农户：" + _toDisplayString(item.farmerName), 1)
                      ]),
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_van_image, {
                          class: "left",
                          fit: "cover",
                          src: item.productUrl
                        }, null, 8, ["src"]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, _toDisplayString(item.productName), 1),
                          _createElementVNode("div", _hoisted_29, _toDisplayString(item.price) + "元/" + _toDisplayString(item.unit), 1),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("span", null, "×" + _toDisplayString(item.totalNumber) + _toDisplayString(item.unit), 1),
                            _createElementVNode("span", null, [
                              _hoisted_31,
                              _createTextVNode(_toDisplayString(item.totalPrice), 1)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["finished", "onLoad"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showDateModal,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDateModal = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_van_datetime_picker, {
            modelValue: _ctx.startDate,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.startDate = $event)),
            type: "date",
            title: "开始日期",
            "min-date": _ctx.startMinDate,
            "max-date": _ctx.startMaxDate,
            "item-height": 30,
            onCancel: _ctx.onCancelDate,
            onConfirm: _ctx.onConfirmDate,
            onChange: _ctx.onStartDateChange
          }, null, 8, ["modelValue", "min-date", "max-date", "onCancel", "onConfirm", "onChange"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_van_datetime_picker, {
            modelValue: _ctx.endDate,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.endDate = $event)),
            type: "date",
            title: "结束日期",
            "min-date": _ctx.endMinDate,
            "max-date": _ctx.endMaxDate,
            "item-height": 30,
            "cancel-button-text": " ",
            "confirm-button-text": " "
          }, null, 8, ["modelValue", "min-date", "max-date"])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showSectionModal,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => (_ctx.showSectionModal = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "请选择",
          columns: _ctx.otherDate,
          onConfirm: _ctx.onSectionConfirm,
          onCancel: _ctx.onSectionCancel,
          "default-index": _ctx.selectedDateWay.id
        }, null, 8, ["columns", "onConfirm", "onCancel", "default-index"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showTypeModal,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => (_ctx.showTypeModal = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "选择品种",
          columns: _ctx.typeList,
          onConfirm: _ctx.onTypeConfirm,
          onCancel: _ctx.onTypeCancel,
          "columns-field-names": _ctx.customPicker
        }, null, 8, ["columns", "onConfirm", "onCancel", "columns-field-names"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}